import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';

interface IntegrationStatusCardsProps {
  stripeConfigured: boolean;
  emailConfigured: boolean;
}

export const IntegrationStatusCards: React.FC<IntegrationStatusCardsProps> = ({ stripeConfigured, emailConfigured }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
      <div className="rounded-2xl border border-strivre-lightnavy bg-white p-5 shadow-sm">
        <div className="flex items-center gap-3">
          {stripeConfigured ? <CheckCircle className="h-6 w-6 text-green-600" /> : <XCircle className="h-6 w-6 text-red-600" />}
          <div>
            <h4 className="font-semibold text-slate-900">Stripe</h4>
            <p className="text-sm text-slate-500">{stripeConfigured ? 'Configured' : 'Not Configured'}</p>
          </div>
        </div>
      </div>

      <div className="rounded-2xl border border-strivre-lightnavy bg-white p-5 shadow-sm">
        <div className="flex items-center gap-3">
          {emailConfigured ? <CheckCircle className="h-6 w-6 text-green-600" /> : <XCircle className="h-6 w-6 text-red-600" />}
          <div>
            <h4 className="font-semibold text-slate-900">System Email</h4>
            <p className="text-sm text-slate-500">{emailConfigured ? 'Configured' : 'Not Configured'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
